import useCatalogs from '../../hooks/useCatalogs'

const Catalogs = ({ children }) => {
  const data = useCatalogs()
  return children(data)
}
export default Catalogs
